type FrameInterpolationSegment = {
    i0: number;
    i1: number;
    t: number;
};

const resolveFrameInterpolationSegment = (
    frames: readonly number[],
    frame: number,
    out: FrameInterpolationSegment
) => {
    const last = frames.length - 1;

    if (frame <= frames[0]) {
        out.i0 = 0;
        out.i1 = 0;
        out.t = 0;
        return out;
    }

    if (frame >= frames[last]) {
        out.i0 = last;
        out.i1 = last;
        out.t = 0;
        return out;
    }

    let lo = 0;
    let hi = last;
    while (lo + 1 < hi) {
        const mid = (lo + hi) >> 1;
        if (frames[mid] <= frame) {
            lo = mid;
        } else {
            hi = mid;
        }
    }

    const i0 = lo;
    const i1 = hi;
    const denom = frames[i1] - frames[i0];
    const alpha = denom > 0 ? (frame - frames[i0]) / denom : 0;

    out.i0 = i0;
    out.i1 = i1;
    out.t = alpha <= 0 ? 0 : (alpha >= 1 ? 1 : alpha);
    return out;
};

export { resolveFrameInterpolationSegment };
export type { FrameInterpolationSegment };